export default "__VITE_ASSET__BBoUktOO__"